import {config} from "~/utils/config.js";
import {omniFetch} from "~/utils/fetch.js";

// https://mobiverse.feishu.cn/docx/SRD9dFZ9voXfO5xOM2Pc2V64n9k
// brandId	否	String	品牌ID（用于brand页面）	1691239759832875010
// category	否	String	分类（用于wishlist页面）	wishlist
// collection	否	String	产品系列（用于new-arrivals、collection页面等）	on-sale、new-arrivals
// search	否	String	搜索关键词（用于search页面）
// wishlist	否	String	"all"/[CAPSULE_ID]（用于wishlist页面）
export function filterInfo({brandId, category, collection, search, wishlist}) {
  return omniFetch({
    url: config.v1Path + config.filterInfoPath,
    method: "get",
    params: {brandId, category, collection, search, wishlist}
  })
}

export function filterSearchBefore() {
  return omniFetch({
    url: config.v1Path + config.filterSearchBeforePath,
    method: "get",
    params: {}
  })
}

/**
 * @typedef {Object} MyFilter
 * @property {Array} size 尺寸数组
 */
/**
 * @param {String} search    关键字
 * @param {Boolean} availableNow 是否只关注可购买项
 * @param {MyFilter} filter 过滤器，当前仅支持size
 * @returns {Promise<Awaited<*> | any | undefined>}
 */
export function filterSearch({search, availableNow, filter}) {
  return omniFetch({
    url: config.v1Path + config.filterSearchPath,
    method: "post",
    params: {
      search,
      availableNow,
      filter
    }
  })
}
